import {
  DataObjectId,
  DealActivityCreatedItem,
  DealActivityDealItem,
  DealActivityNoteItem,
  Hub
} from 'yougile-model'

export const getDealActivity = (
  hub: Hub
):
  | (DealActivityCreatedItem | DealActivityNoteItem | DealActivityDealItem)[]
  | undefined => {
  // NOTE: backward compatibility with deprecated
  // format of fields (was made in CRM beta-version),
  // can be safely removed after ~15 July 2025.
  // TODO: fix in ENT-739 - remove activity
  if (!hub.data?.dealActivity) {
    const legacyData = hub.data as any
    if (legacyData?.activity) {
      hub.data.dealActivity = {}
      for (const item of legacyData.activity) {
        hub.data.dealActivity[item.id] = item
      }
      hub.commit()
    }
  }

  return Object.values(hub.data?.dealActivity ?? {})
}

export const getDealActivityById = (
  hub: Hub,
  id: DataObjectId
):
  | (DealActivityCreatedItem | DealActivityNoteItem | DealActivityDealItem)
  | undefined => {
  // TODO: fix in ENT-739 - remove activity
  return getDealActivity(hub)?.find(item => item.id === id)
}
